import { mapActions, mapGetters } from "vuex";

export const ViewStateMixin = {
  data: () => {
    return {
      viewId: null,
      viewState: null,
      clockActive: false,
      viewStateSaveDelay: 0
    };
  },
  computed: {
    ...mapGetters("viewState", { getViewState: "viewState" })
  },
  methods: {
    ...mapActions("viewState", ["updateViewState"]),
    async saveViewState() {
      const viewId = this.viewId;
      const viewState = this.viewState;
      await this.updateViewState({ viewId, viewState });
    },
    saveViewStateLater() {
      if (!this.clockActive) {
        this.clockActive = true;
        this.runViewStateSaveClock();
      }
      this.viewStateSaveDelay = 300;
    },
    stopViewStateSaveClock() {
      this.clockActive = false;
      this.viewStateSaveDelay = 0;
    },
    runViewStateSaveClock() {
      if (!this.clockActive) {
        return;
      }
      if (this.viewStateSaveDelay > 0) {
        this.viewStateSaveDelay -= 100;
        if (this.viewStateSaveDelay === 0) {
          this.saveViewState();
        }
      }
      setTimeout(() => this.runViewStateSaveClock(), 100);
    }
  }
};
